import { CHARS } from '@hyakki/core/data/chars';
import { ENEMIES } from '@hyakki/core/data/enemies';
import { esc } from '../ui/dom';
import type { StoryLine } from '@hyakki/core/data/stories';

// ADV専用の等身立ち絵。戦闘・図鑑のちびキャラ素材とは独立して管理する。
// 本編の敵は各国の大将（敵ヒーロー＝操作キャラ。core の data/leaders.ts・COUNTRIES の commander）1体。九尾の影は外伝（ユズハ）で使う。
const NAMED_PORTRAIT_SOURCES: Readonly<Record<string, string>> = {
  r01: 'r01', e020: 'e020', r03: 'r03', r04: 'r04', e050: 'e050',
  e060: 'e060', e070: 'e070', r08: 'r08', e090: 'e090', e100: 'e100',
  e030: 'e030',
};
export const STORY_ENEMY_PORTRAITS: Readonly<Record<string, string>> = Object.freeze(Object.assign(Object.create(null),
  Object.fromEntries(Object.entries(NAMED_PORTRAIT_SOURCES)
    .map(([id, source]) => [id, `/art/story-enemies/${source}.webp?v=named-5`]))));

export function storyCastForLine(line: StoryLine): string[] {
  const cast = [...line.scene.cast];
  if (line.speaker === 'narrator' || line.speaker === 'player' || cast.includes(line.speaker)) return cast;
  const enemy = !!STORY_ENEMY_PORTRAITS[line.speaker];
  if (cast.length < 2) enemy ? cast.push(line.speaker) : cast.unshift(line.speaker);
  else cast[enemy ? 1 : 0] = line.speaker;
  return cast;
}
export function speakerName(id: string, player?: { displayName: string; needsName: boolean } | null) {
  if (id === 'narrator') return '';
  if (id === 'player') return (player && !player.needsName && player.displayName.trim()) || 'あなた';
  return CHARS[id as keyof typeof CHARS]?.name ?? ENEMIES[id]?.name ?? id;
}
/** 立ち絵の URL（無ければ undefined） */
export const actorPortrait = (id: string): string | undefined => (CHARS[id as keyof typeof CHARS] ? `/art/portraits/${id}.webp?v=cast-2` : STORY_ENEMY_PORTRAITS[id]);
export function actorHtml(id: string, active = false) {
  const hero = CHARS[id as keyof typeof CHARS];
  const enemy = ENEMIES[id];
  const cls = `story-actor ${hero ? 'hero' : 'enemy'} ${active ? 'speaking' : 'listening'}`;
  const portrait = actorPortrait(id);
  if (portrait) return `<div class="${cls}" data-actor="${esc(id)}"><img src="${portrait}" alt="${esc(hero?.name ?? enemy?.name ?? id)}" draggable="false" decoding="async"></div>`;
  return '';
}
export function storyBackground(key: string) {
  return key === 'village' ? '/art/ui/top-bg.webp' : `/art/battlefield/${key}.webp`;
}
